import {
    bindFormFields,
    type FormFieldBinding,
    type SelectOption
} from '../../../components/formFields';
import FormRow from '../../../components/FormRow';
import FormSectionBox from '../../../components/FormSectionBox';
import type { DescriptionFormValues } from './descriptionFormValues';

/**
 * Where on the excavation the description sits: its Flurstück, and the
 * Fläche/Schnitt/Sondage slots. These moved OFF the Befund onto each
 * description, so a Befund appearing in two Flächen can say so.
 */
export default function LocationSection({
    binding,
    titlePrefix,
    parcelOptions,
    suggestions
}: {
    binding: FormFieldBinding<DescriptionFormValues>;
    titlePrefix: string;
    parcelOptions: readonly SelectOption[];
    /** Slots backtracked from this project's own rows. */
    suggestions: {
        area: readonly string[];
        trench: readonly string[];
        sondage: readonly string[];
    };
}) {
    const { suggest, select } = bindFormFields(binding);
    return (
        <FormSectionBox titlePrefix={titlePrefix} id="location">
            <FormRow>
                {/* Clearable: a description need not sit on a known Flurstück. */}
                {select('parcelId', parcelOptions, { clearable: true })}
                {suggest('area', suggestions.area)}
            </FormRow>
            <FormRow>
                {suggest('trench', suggestions.trench)}
                {suggest('sondage', suggestions.sondage)}
            </FormRow>
        </FormSectionBox>
    );
}
